import React from "react";
/* Import Boostrap */
import { Row, Navbar, Nav } from 'react-bootstrap';

import HeaderLogo from "./logo";
import Menu from "../menu/menu";
import SectionContainer from '../containers/section-container';

export default class Header extends React.Component {
  //sets the menu state  
  state = {
    expanded: {}
  }  

  setNavExpanded = (expanded) => {
    this.setState({ navExpanded: expanded });
    if ( expanded ) {
        //block scroll when opening the menu on mobile
        document.body.style.overflow = "hidden"
    } else {
        document.body.style.overflow = "initial"
    }
  }
  //closes the menu
  closeNav = () => {
    this.setState({ navExpanded: false });
    document.body.style.overflow = "initial"
  }

    render() {
        return(
            <nav className="gtco-nav navbar navbar-default navbar-fixed-top">
                <SectionContainer>
                    <Row>
                        <Navbar onToggle={this.setNavExpanded} expanded={this.state.navExpanded}>
                            <Navbar.Header>
                                <Navbar.Brand>
                                    <HeaderLogo logoContent= { this.props.logoContent } />
                                </Navbar.Brand>
                                <Navbar.Toggle />
                            </Navbar.Header>
                            <Navbar.Collapse>
                            <Nav pullRight className="text-right menu-1">
                                <Menu menuitems={this.props.menuitems} langMenu={this.props.lang} closeNav={ this.closeNav }/>
                            </Nav>
                            </Navbar.Collapse>
                        </Navbar>
                    </Row>
                </SectionContainer>
            </nav>
        )
    }
} 




// WEBPACK FOOTER //
// ./src/components/header/header.js